import React, { useState, useEffect } from 'react';
import { List, Input, message } from 'antd';
import { getConfig, updateConfig } from '../../api/settings';

const LinkedInUserConfig = () => {
    const [formState, setFormState] = useState({
      linkedinClientId: '',
      linkedinClientSecret: ''
    });
    const [isEditing, setIsEditing] = useState(false);
  
    const getConfigData = async () => {
      try {
        const response = await getConfig();
        if (response) {
          setFormState({
            linkedinClientId: response.linkedinClientId || '',
            linkedinClientSecret: response.linkedinClientSecret || ''
          });
        }
      } catch (error) {
        console.error(error);
      }
    };
  
    const handleInputChange = (field, value) => {
      setFormState(prev => ({
        ...prev,
        [field]: value
      }));
    };

  useEffect(() => {
    getConfigData();
  }, []);

  const handleUpdateClick = async () => {
    setIsEditing(!isEditing);
    if (isEditing) {
      const response = await updateConfig(formState);
      if (response) {
        message.success(response.message);
        getConfigData();
      } else {
        message.error(response.message);
      }
    }
  };

  const renderSecretValue = (value) => {
    if (value?.length > 3) {
      const firstThree = value?.slice(0, 3);
      const lastThree = value?.slice(-3);
      const middlePart = value?.slice(3, -3).replace(/./g, '*');
      return firstThree + middlePart + lastThree;
    }
    return value;
  };

  const linkedInData = [
    {
      title: 'Client Id',
      description: formState?.linkedinClientId || '',
    },
    {
      title: 'Client Secret',
      description: formState?.linkedinClientSecret || '',
    },
  ];

  return (
    <>
      <List
        header={<div>Change Settings</div>}
        size="medium"
        bordered
        dataSource={linkedInData}
        renderItem={(item) => (
          <List.Item>
            <List.Item.Meta
              title={item.title}
              description={
                item.title === 'Client Secret' ? (
                  isEditing ? (
                    <Input.Password
                      value={formState.linkedinClientSecret}
                      onChange={(e) => handleInputChange('linkedinClientSecret', e.target.value)}
                    />
                  ) : (
                    renderSecretValue(item.description)
                  )
                ) : (
                  isEditing ? (
                    <Input.Password
                      value={formState.linkedinClientId}
                      onChange={(e) => handleInputChange('linkedinClientId', e.target.value)}
                    />
                  ) : (
                    renderSecretValue(item.description)
                  )
                )
              }
            />
          </List.Item>
        )}
      />
      <div className="text-end">
        <a
          onClick={handleUpdateClick}
          key="list-loadmore-edit"
          className="btn btn-outline-dark"
        >
          {isEditing ? 'update' : 'edit'}
        </a>
        {isEditing && (
          <a
            onClick={() => setIsEditing(!isEditing)}
            key="list-loadmore-cancel"
            className="btn btn-outline-dark"
          >
            cancel
          </a>
        )}
      </div>
    </>
  );
};

export default LinkedInUserConfig;